import { render, staticRenderFns } from "./NarrationDisabledIcon.vue?vue&type=template&id=7c5b5a10&"
import script from "./NarrationDisabledIcon.vue?vue&type=script&lang=js&"
export * from "./NarrationDisabledIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports